import { DOCTYPES } from '@/constants/doctypes'

const getDefaultKanbanBoardName = (doctype: string): string => {
  if (doctype === DOCTYPES.OPPORTUNITY) {
    return 'Standard-Deal'
  }

  return `Standard-${doctype}`
}

export { getDefaultKanbanBoardName }
